export default __webpack_public_path__ + "static/media/pagination-label-back.c6421b46.svg";